import React from "react";
import { BsArrowRight } from "react-icons/bs";

const PreSaleWorking = () => {
  return (
    <div id="how-it-works" className="how-it-works container">
      <div className="container">
        <div className="about-gangsta">
          {/* <p className="pre-title">What is gangstabet</p> */}
          <p className="about-title">How does it work? </p>
          <p className="about-subtitle">
            GangstaBets are created as ICON’s Non-Fungible Token (NFT) standard, IRC-3 (similar to Ethereum’s ERC721). Each character is an animated GIF and stored in the IPFS. They ensure that the images are permanently stored in the blockchain, and there is no single point of failure to map the images to the metadata. We will make sure that GangstaBet will continue to remain in existence forever without our presence. All the characters were generated programmatically and were not initially indexed. While buying during the pre-sale, the on-chain algorithm randomly picked the NFTs for each address. This mechanism ensured that the distribution was completely fair and transparent.

            <br />
            <br />

            During the genesis of the characters (on-chain), a class was randomly assigned to them based on a probability algorithm. The properties of the character are assigned based on the class. The names were empty and the skills were minimal at the start. Only the owners of the GangstaBet are able to increase their skills. <strong>During pre-sale, we provided additional $GBET that could be used to change their names & increase their skills. </strong>
          </p>
        </div>

      </div>
    </div>
  );
};

export default PreSaleWorking;
